/**
 * 客户端错误上报的统一入口。
 * 当前仅输出到控制台；接入 Sentry 等统一监控时只需替换此实现，
 * 所有错误边界即自动获得上报能力。
 * @param scope 错误来源标识，例如 'app'、'editor-canvas'，用于日志定位。
 * @param error 捕获到的错误对象。
 * @param componentStack 可选的 React 组件栈，来自错误边界的 errorInfo。
 */
export function reportClientError(scope, error, componentStack) {
    // 只输出错误消息、堆栈与组件栈，不记录剧本内容或令牌等敏感数据。
    console.error(`[client-error:${scope}]`, error, componentStack);
}
